<div class="cards-grid" [@inListAnimation]="list?.length">
  <ng-container *ngFor="let item of list; trackBy: trackByName; let index = index">
    <tpm-module-card
      [isMobile]="isMobile"
      [props]="item"
      [newsProps]="news && (news[item.moduleId] ?? news[item.name])"
      (moduleCardClicked)="moduleCardClicked.emit(item)"
      (storytellerButtonClicked)="storytellerButtonClicked.emit(item)"
      (leadButtonClicked)="leadButtonClicked.emit(item)"
      (productButtonClicked)="productButtonClicked.emit(item)"
      (innerNewsCardButtonClicked)="innerNewsCardButtonClicked.emit($any($event))"
    ></tpm-module-card>
    <tpm-buffer-card
      *ngIf="index === list?.length - 1"
      (newsButtonClicked)="newsButtonClicked.emit()"
    ></tpm-buffer-card>
  </ng-container>
</div>
